import { colorTokens } from '../variables';

export const StyledButtonSx = [
  {
    color: colorTokens.primary.contrast,
    backgroundColor: colorTokens.primary.main,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: 'none',
    },
    '&:active,focus': {
      outline: 'none',
    },

    '&.MuiButton-contained': {
      color: colorTokens.primary.contrast,
      border: `1px solid ${colorTokens.primary.outlineBorder}`,
      '&:hover': {
        border: `1px solid ${colorTokens.primary.outlineBorder}`,
        backgroundColor: colorTokens.primary.light,
        boxShadow: 'none',
      },
      '&:focus': {
        border: `1px solid ${colorTokens.primary.outlineBorder}`,
        boxShadow: 'none',
        outline: `2px solid ${colorTokens.secondary.main}`,
      },
      '&:active': {
        backgroundColor: colorTokens.primary.dark,
        border: `1px solid ${colorTokens.primary.outlineBorder}`,
        boxShadow: 'none',
      },
      '&:active,focus': {
        outline: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: colorTokens.primary.disabled,
        color: colorTokens.primary.contrast,
        border: 'none',
      },
    },
    '&.MuiButton-text': {
      color: colorTokens.primary.main,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
        color: colorTokens.primary.dark,
      },
      '&:focus': {
        boxShadow: 'none',
        outline: `2px solid ${colorTokens.secondary.main}`,
      },
      '&:active': {
        color: colorTokens.primary.light,
      },
      '&:active,focus': {
        outline: 'none',
      },
      '&.Mui-disabled': {
        color: colorTokens.text.disabled,
        border: 'none',
      },
    },

    '&.MuiButton-containedSecondary': {
      backgroundColor: colorTokens.info.main,
      border: `1px solid ${colorTokens.primary.outlineBorder}`,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: colorTokens.info.light,
        border: `1px solid ${colorTokens.info.outlineBorder}`,
        boxShadow: 'none',
      },
      '&:focus': {
        border: `1px solid ${colorTokens.info.outlineBorder}`,
        boxShadow: 'none',
        outline: `2px solid ${colorTokens.secondary.main}`,
      },
      '&:active': {
        backgroundColor: colorTokens.info.dark,
        border: `1px solid ${colorTokens.info.outlineBorder}`,
        boxShadow: 'none',
        outline: 'none',
      },
      '&:active,focus': {
        outline: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: colorTokens.primary.disabled,
        color: colorTokens.primary.contrast,
        border: 'none',
      },
    },
  },
];

export const TonalButtonSx = [
  {
    '&.MuiButton-contained': {
      color: colorTokens.primary.main,
      backgroundColor: colorTokens.tonal.contrast,
      border: `1px solid ${colorTokens.primary.outlineBorder}`,
      boxShadow: 'none',
      '&:hover': {
        color: colorTokens.primary.main,
        backgroundColor: colorTokens.tonal.light,
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
        outline: `2px solid ${colorTokens.secondary.main}`,
      },
      '&:active': {
        color: colorTokens.primary.main,
        backgroundColor: colorTokens.tonal.dark,
      },
      '&:active,focus': {
        outline: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: colorTokens.primary.disabled,
        color: colorTokens.primary.contrast,
        border: 'none',
      },
    },
  },
];

export const TonalVariantButtonSx = [
  {
    '&.MuiButton-contained': {
      color: colorTokens.primary.main,
      backgroundColor: colorTokens.tonal.light,
      border: `1px solid ${colorTokens.border.dark}`,
      boxShadow: 'none',
      '&:hover': {
        color: colorTokens.primary.main,
        backgroundColor: colorTokens.tonal.contrast,
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
        outline: `2px solid ${colorTokens.secondary.main}`,
      },
      '&:active': {
        color: colorTokens.primary.main,
        backgroundColor: colorTokens.tonal.dark,
      },
      '&:active,focus': {
        outline: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: colorTokens.primary.disabled,
        color: colorTokens.primary.contrast,
        border: 'none',
      },
    },
  },
];

export const WarningButtonSx = [
  {
    '&.MuiButton-contained': {
      color: colorTokens.error.dark,
      backgroundColor: colorTokens.error.button,
      border: `1px solid ${colorTokens.error.outlineBorder}`,
      boxShadow: 'none',
      '.MuiButton-startIcon': {
        marginLeft: '0px',
        marginRight: '0px',
      },
      '&:hover': {
        backgroundColor: colorTokens.error.buttonHover,
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
        outline: `2px solid ${colorTokens.secondary.main}`,
      },
      '&:active': {
        color: colorTokens.error.outlineBorder,
        backgroundColor: colorTokens.error.buttonActive,
      },
      '&:active,focus': {
        outline: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: colorTokens.primary.disabled,
        color: colorTokens.primary.contrast,
        border: 'none',
      },
    },
  },
];
